
<template>
  <div>
    <LinkTitle></LinkTitle>
    <div class="searchCommodity">
      <div class="imgWrap">
        <PageSearchTitle searchSize="big" :showCart="false" width="600" @goodschild-event='goodsParentEvent'  :placeholder="$route.query.typeName||''" />
      </div>
      <div class="storeWrap">
        <div class="storeWrapleft">推荐搜索</div>
        <div class="space hidden"></div>
        <div class="btnBox">
          <div class="btnBox" v-for="(item, index) in searchValue" :key="index">
            <div class="textHover mainType btn" @click="storeKind(item)">
              {{ item }}
            </div>
            <div v-show="index != searchValue.length - 1">
              <el-divider class="divider" direction="vertical"></el-divider>
            </div>
          </div>
        </div>
      </div>
      <div :class="searchCommodityDisplay ? 'searchCommodityShow' : 'searchCommodityDown'">
      <div class="orderBox" >
        <el-radio-group v-model="radio1" class="selectSort" @change="selectSortChange">
          <el-radio-button :label="2" name="sort1" ><div>价格升序<i class="el-icon-top"></i></div></el-radio-button>
          <el-radio-button :label="1" name="sort1" ><div>价格降序<i class="el-icon-bottom"></i></div></el-radio-button>
          <el-radio-button :label="3" name="sort1" ><div>销量升序<i class="el-icon-top"></i></div></el-radio-button>
          <el-radio-button :label="4" name="sort1" ><div>销量降序<i class="el-icon-bottom"></i></div></el-radio-button>
        </el-radio-group>
        
      </div>

      <div class="recommendGoods">
        <div
          class="allGoodsListItemBox"
          @click="storeItemClick(item)"
          v-for="(item, index) in allGoodsList"
          :key="index"
        >
          <el-image
            fit="cover"
            :lazy="true"
            :src="getImageUrl(item.coverPlan)"
            class="goodsRecommendImage"
          ></el-image>

          <div class="allGoodsListItemInfo">
            <div class="allGoodsListItemInfoName">{{ item.name }}</div>
            <div class="bottom">
              <div class="allGoodsListIteStoreName">
                {{ item.price }}<span>元/{{ item.unit }}</span>
              </div>
              <div class="allGoodsListIteStoreSaleNumber">
                已售{{ item.sale_number || 0 }}{{ item.buyUnit }}
              </div>
            </div>
          </div>

        </div>
        <div class="imgShow" v-if="imgShow">
          <img src="../assets/img/notresult.png" alt="" >
        </div>
        
        
      </div>
      
      </div>
    <Footer></Footer>
  </div>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";

import {
  queryBannerListUrl,
  queryAllClassCategry,
  queryAllGoodsList,
  baseUrl,
  queryStoreList,
  getImageUrl,
  pcGetHomerecomentStore,
  isBeijing,
  queryMyGoodsList,
  queryStoreDateUrl,
} from "@/api/api";
import city from "@/utils/city";

export default {
  data() {
    return {
      bannerListData: [],
      firstClassList: [],
      secondData: [],
      allGoodsList: [],
      storeListData: [],
      classSubStatus: true,
      searchCommodityDisplay:true,
      searchStoreList:[],
      searchStoreInput:"",
      inputValue: "",
      bodyW: "",
      radio1:"",
      stName:"",
      imgShow:false,
      selectSortSortDirection:"",
      selectSortSearchType:"",
      searchValue: [
        "白条",
        "黑猪",
        "花猪",
        "分割品",
        "副产品",
        "五花肉",
        "酱类",
        "绑卡专用",
      ],
    };
  },

  props: ["gid"],
  components: {
    PageSearchTitle,
  },
  created() {
    this.getImageUrl = getImageUrl;
    console.log(this.$route.query.typeName)
    // this
  },
  mounted() {
    this.initBannerData();
    this.initGoodsListData();
    this.initClassCategory();
    this.initStoreData();
    setTimeout(() => {
      this.bodyW = document.getElementsByClassName("baClStWrap")[0].clientWidth;
    }, 10);
    window.onresize = () => {
      return (() => {
        this.bodyW = document.getElementsByClassName(
          "baClStWrap"
        )[0].clientWidth;
      })();
    };
  },

  methods: {
    toStoreHomePage(item) {
      console.log(item);
      this.$router.push({
        name: "storeHomePage",
        query: {
          store_id: item.storeId,
        },
      });
    },
    toSupplyPage() {
      this.$router.push("/supplyPage");
    },
    toDemandPage() {
      this.$router.push("/demandPage");
    },
    search({ typeId, typeName }) {
      this.$router.push({
        name: "searchCommodity",
        query: {
          typeId,
          // typeName,
        },
      });
    },
    errorHandler() {
      return true;
    },
    storeKind(kind) {
      if (kind == 4) {
        this.$router.push({
          name: "searchCommodity",
          query: {
            birthType: 2,
          },
        });
      } else {
        this.$router.push({
          name: "searchCommodity",
          query: {
            kind,
          },
        });
      let url = queryAllGoodsList;
      let data = {
        // name:this.$route.query.typeName,
        pageSize: 120,
        pageIndex: 0,
        name:this.$route.query.kind,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.allGoodsList = data;
            if(this.allGoodsList==""){
              this.imgShow=true
            }else{
              this.imgShow=false
            }
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });


      }
    },
    searchFocus() {
      console.log(777);
      this.$router.push({
        name: "searchCommodity",
        query: {
          name: "",
        },
      });
    },
    renderImg(url) {
      return `${baseUrl}/${url}`;
    },

    initBannerData() {
      let that = this;
      let url = queryBannerListUrl;
      let data = {
        type: 1,
        visible: 1,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.bannerListData = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },

    initClassCategory() {
      let that = this;
      let url = queryAllClassCategry;
      let data = {};
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.firstClassList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },

    initGoodsListData() {
      // let that = this;
      let url = queryAllGoodsList;
      let data = {
        name:this.$route.query.typeName,
        pageSize: 120,
        pageIndex: 0,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            if (data && data.length && !isBeijing) {
              // alert(1)
              data = data.filter((item) => {
                return item.storeName.indexOf("中农亿家") < 0;
              });
            }
            console.log("dataf", data);
            this.allGoodsList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },
    initStoreData() {
      let that = this;
      let url = pcGetHomerecomentStore;
      let data = {
        pageSize: 8,
        pageIndex: 0,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.storeListData = data ? data : [];
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },

    enter(item) {
      console.log(item);
      const { tlist } = item;
      this.secondData = tlist;
      this.classSubStatus = false;
    },

    leave() {
      this.classSubStatus = true;
    },

    subClassEnter() {
      this.classSubStatus = false;
    },

    subClassLeave() {
      this.classSubStatus = true;
    },

    thirdClassClick(thirdItem) {
      console.log(thirdItem);
      let { typeId, typeName } = thirdItem;
      console.log("thirdItem", thirdItem);
      this.$router.push({
        name: "searchCommodity",
        query: {
          typeId: typeId,
          typeName,
        },
      });
    },
    login() {
      this.$router.push({ path: "/login", params: { a: "asdf" } });
    },

    storeItemClick(item) {
      // this.$router.push({ path:'/goodsDetial',pageParam:item})
      let { id } = item;
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: id,
          type: -1,
        },
      });
    },
    parentEvent(data1,data2){
      console.log(data1+data2);
      this.searchCommodityDisplay=data1;
      this.searchStoreInput=data2;
      console.log(this.searchCommodityDisplay)
      let that = this;
      let url = queryMyGoodsList;
      let data = {
        keyword: this.searchStoreInput,
        pageSize:999,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      }).then((res) => {
        // console.log(res);
        let { data } = res.data;
        console.log("datai", data);
        this.searchStoreList = data;
      });
    },
    toStoreContent(item){
      // console.log(aaaa)
      this.$router.push({
        name: "storeHomePage",
        query: {
          store_id: item.storeId,
        },
      });
    },
    selectSortChange(){
      console.log(this.radio1)
      let that = this
      if (this.radio1!=3&&this.radio1!=3){
        this.selectSortSearchType=this.radio1;
        let url = queryAllGoodsList;
        that.stName=this.$route.query.typeName;
        console.log(that.stName)
        let data = {
          name:this.$route.query.typeName,
          pageSize: 120,
          pageIndex: 0,
          searchType:this.selectSortSearchType,
          
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            let { data } = res.data;
            if (data && data.length && !isBeijing) {
              // alert(1)
              data = data.filter((item) => {
                return item.storeName.indexOf("中农亿家") < 0;
              });
            }
            console.log("dataf", data);
            this.allGoodsList = data;
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
      }else {
        if(this.radio1==3){
          this.selectSortSortDirection="ASC";
        }else{
          this.selectSortSortDirection="DESC";
        }
        let url = queryAllGoodsList;
        let data = {
          // name:this.$route.query.typeName,
          pageSize: 120,
          pageIndex: 0,
          sortDirection:this.selectSortSortDirection,
          // name:decodeURI(this.$route.query.typeName),
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              let { data } = res.data;
              if (data && data.length && !isBeijing) {
                // alert(1)
                data = data.filter((item) => {
                  return item.storeName.indexOf("中农亿家") < 0;
                });
              }
              console.log("dataf", data);
              this.allGoodsList = data;
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch((err) => {
            this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
          });
      }
    },
    goodsParentEvent(data1){
      let url = queryAllGoodsList;
      let data = {
        // name:this.$route.query.typeName,
        pageSize: 120,
        pageIndex: 0,
        name:data1,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.allGoodsList = data;
            if(this.allGoodsList==""){
              this.imgShow=true
            }else{
              this.imgShow=false
            }
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
    },
    register() {},

    myOrder() {},

    myShoppingCart() {},

    sellerCenter() {},

    handleIconClick() {},
    myShoppingCart() {},

    sellerCenter() {
      this.$router.push({
        name: "sellCenter",
      });
    },

    handleIconClick() {},
  },
  computed: {
    firstClassifyItemFontSize() {
      return (((this.bodyW - 360) / 750) * 300) / 10 - 20 > 16
        ? 16
        : (((this.bodyW - 360) / 750) * 300) / 10 - 20;
    },
    imgH() {
      return ((this.bodyW - 360) / 750) * 300;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and(min-width:320px) and(max-width:1200px) {
  .searchCommodity {
    margin: 5px 10px 0 !important;
  }
}
.el-pagination{
  width: 800px;
}
.searchStore{
  display: flex;
  width: 1600px;
  align-items: center;
  // padding-left: 150px;
  padding-right: -150px;
  .searchStoreShow{
    width: 49%;
    height: 190px;
    float: left;
    background-color: rgba(211, 209, 205, 0.705);
    margin: 8px;
    // padding-left: 20px;
    img{
      display: block;
      float: left;
      width: 90px;
      height: 90px;
      border-radius: 15px;
      margin-top: 50px;
      margin-left: 50px;
    }
    .storeContent{
      // display: inline-block;
      float: left;
      height: 120px;
      width: 550px;
      margin-top: 40px;
      margin-left: 30px;
      p{
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      h5{
        margin-bottom: 8px;
      }
      span,a{
        font-size: 14px;
        margin-right: 3px;
      }
      h6{
        font-weight: normal;
        margin-top: 18px;
        color: rgb(143, 140, 140);
      }
    }
  }
  
}

.clear{
    clear: auto;
  }
.el-radio-button {
  background-color:#ff9800;
}
.searchCommodity .searchCommodityShow{
  display: block;
  height: auto;
}
.searchCommodityDown{
  display: none;
  height: auto;
}

.borderTop {
  border-top: 1px solid #ccc;
}
.searchCommodity {
  margin: 5px 150px 0;
}
// .imgWrap {
//   display: flex;
//   justify-content: "space-between";
//   align-items: flex-start;
//   // align-items:center;
// }

.secondClass {
  width: 20%;
  text-align: center;
  color: #333;
  // background-color:red
}

.thirdClassWrap {
  color: #999;
  width: 100%;
  display: flex;
  // justify-content: space-around;
  flex-wrap: wrap;

  // background-color:green;
  // border-bottom: 1px solid #ccc;
  div {
    margin: 0 6px;
  }
}

.classRightItem {
  width: 100%;
  min-height: 40px;
  display: flex;
  justify-content: space-around;
  margin: 8px 0;
}

.firstClassWrap {
  width: 150px;
  position: absolute;
  top: 50px;
  left: 0px;
  z-index: 100;
  background-color: rgba(105, 105, 105, 0.5);

  div {
    display: block;
    width: 100%;
    height: 50px;
    text-align: "center";
    line-height: 50px;
    color: #fff;
  }
}
.bannerContent {
  display: flex;
  justify-content: "center";
  background-color: #ccc;
}

.bannerImgWrap {
  margin: 0;
  width: 100%;
  height: 500px;
}

.bannerWrap {
  width: 1000px;
  background-color: purple;
  height: 500px;
  margin: 0 auto;
}

// .bannerImg {
// }
.recommend {
  width: 100%;
  height: 80px;
  text-align: center;
  line-height: 80px;
  color: #454545;
  font-size: 33px;
  font-weight: 600;
  background-color: "#f4f4f4";
}
.hide {
  display: none;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  height: 20px;
  line-height: 30px;

  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
// .goodsRecommendImage:hover {
//   // transform: scale(1.05);
// }
.allGoodsListIteStoreName {
  color: #f40;
  font-size: 18px;
  span {
    font-size: 14px;
    color: #999;
    margin-left: 3px;
  }
}
.button {
  padding: 0;
  float: right;
}

.goodsRecommendImage {
  height: 180px;
  width: 300px;
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.header {
  width: 70%;
  height: 40px;
  margin: 0 auto;
}

.clearfix:after {
  clear: both;
}

.header {
  width: 100%;
  height: 30px;
  background-color: #e3e4e5;
}
.headerContent {
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  color: #929296;
}

.searchWrap {
  width: 90%;
  padding: 40px;
}

.storeWrap {
  display: flex;
  padding-right: 182px;
  background-image: linear-gradient(to right, #ff9800eb, #f70);

  margin-top: 10px;
  margin-bottom: 10px;
  .btn {
    font-size: 14px;
    height: 30px;
    text-align: center;

    color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: 400;
  }
}

.storeListWrap {
  width: 150px;
  background-color: green;
  position: absolute;
}

.baClStWrap {
  border: 1px solid #ccc;
  // border-top: 0;
  display: flex;
  .classifyWrap {
    width: 180px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-right: 1px solid #ccc;
    .firstClassifyItem {
      width: 100%;
      flex: 1;
      font-size: 15px;
      color: #666;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .bannersWrap {
    flex: 1;
    position: relative;
    .subClassify {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      z-index: 100;
      border: 1px solid #ccc;
      border-left: none;
      font-size: 14px;
      color: #666;
    }
  }

  .storesWrap {
    width: 180px;
    height: 100%;
    // background-color: yellow;
    border-left: 1px solid #ccc;
    .storeRecommendText {
      font-size: 20px;
      height: 50px;
      line-height: 50px;
      color: #7f94bf;
      text-align: center;
      border-bottom: 1px solid #ccc;
    }
    .storeItem {
      width: 100%;
      flex: 1;
      border-top: 1px solid #ccc;
      display: flex;
      align-items: center;
      padding-left: 5px;

      box-sizing: border-box;
      .storeHead {
        overflow: hidden;
        margin-left: 5px;
      }
      .storeContentRight {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 10px;
        .storeName {
          color: #666;
          width: 100px;
          // width: 100%;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .storeIntroduce {
          color: #999;
          font-size: 10px;
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .recommendCommodityWrap {
    width: "70%";
    border: 1px solid green;
    margin: 0 auto;
  }
}

.secondClassRightText {
  color: #666;
  margin-left: 6px;
}
.allGoodsListItemBox {
  width: 300px;
  // float: left;
  margin-bottom: 15px;
  background-color: #fff;
  border: 1px solid transparent;
  margin-right: 5px;
  margin-left: 5px;
}
.allGoodsListItemBox:hover {
  cursor: pointer;
  background-color: #f01e1e;
  border: 1px solid #f01e1e;
  transform: scale(1.05);
}
.allGoodsListItemBox:hover .allGoodsListItemInfoName,
.allGoodsListItemBox:hover .allGoodsListIteStoreName,
.allGoodsListItemBox:hover .allGoodsListIteStoreName span,
.allGoodsListItemBox:hover .allGoodsListIteStoreSaleNumber {
  color: #fff;
}

.recommendGoods {
  overflow: hidden;
  background-color: #f6f6f6;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  // align-items: center;
  // height:600px;
  flex-wrap: wrap;
  padding: 20px 5px;
  margin-top: 10px;
}
.allGoodsListItemInfoName {
  height: 40px;
  // background-color: red;
  line-height: 30px;
  color: #545454;
  font-size: 14px;
  // background-color: blue;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-family: sans-serif, "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS";
}
.mainType {
  color: #f70;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.allGoodsListIteStoreSaleNumber {
  color: #999;
}
.storeWrapleft {
  width: 182px;
  background-color: #f60;
  border-radius: 0;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
.space {
  width: 2px;
  height: 16px;
  margin: 7px 10px;
  background-color: #fff;
}
.allGoodsListItemInfo {
  margin: 10px 20px;
}
.hidden {
  color: transparent !important;
  background-color: transparent !important;
}
.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.divider {
  background-color: #fff;
}
.orderBox {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #eee;
  padding: 10px;
}
.paging{
  width: 600px;
  margin: 0 auto;
}
.imgShow{
  width: 250px;
  /* height: 400px; */
  margin: 150px auto 80px;
}
.imgShow img{
  width: 100%;
}
</style>


<style >
.selectSort .el-radio-button__orig-radio:checked+ .el-radio-button__inner{
    
    color: #fff!important;
    background-color: #f01e1e!important;
    border-color: #f01e1e!important;
}
.selectSort .el-radio-button__inner:hover{
    color: #f01e1e!important;
}
.selectSort .el-icon-top::before{
  vertical-align: -2px;
}
.selectSort .el-icon-bottom{
  vertical-align: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchCommodity.vue